/**
 * Convierte la lista plana de menu_items (del backend) en el formato que
 * espera el componente `Tree` de antd: nodos con `key`, `title` y `children`.
 *
 * - Respeta el campo `order` al ordenar hermanos.
 * - Items cuyo `parentId` no existe en la lista se tratan como raíces
 *   (defensa contra datos inconsistentes, no debería pasar en producción).
 */
const buildTree = (items) => {
  if (!Array.isArray(items) || items.length === 0) return [];

  const byId = new Map();
  items.forEach((it) => {
    byId.set(it.id, { ...it, children: [] });
  });

  const roots = [];
  byId.forEach((node) => {
    if (node.parentId != null && byId.has(node.parentId)) {
      byId.get(node.parentId).children.push(node);
    } else {
      roots.push(node);
    }
  });

  const sortRec = (arr) => {
    arr.sort((a, b) => (a.order ?? 0) - (b.order ?? 0));
    arr.forEach((n) => sortRec(n.children));
  };
  sortRec(roots);

  const toTreeNode = (node) => ({
    key: String(node.id),
    title: `${node.label}  ·  ${node.route}  ·  ${node.userType ?? '—'}`,
    raw: node,
    children: node.children.map(toTreeNode),
  });

  return roots.map(toTreeNode);
};

export default buildTree;
